import Tasks from 'APP/Tasks';
import bus from 'APP/packages/bus';
import Entities from 'STORE';
import { ChatMessage } from 'STORE/Messages/Message/ChatMessage/ChatMessage';
import { Quote } from 'STORE/Messages/Message/Quote/Quote';

export const startQuote = async (message: ChatMessage, text: string): Promise<void> => {
  const forwardedSource = message.forward;

  const source = forwardedSource
    ? {
        unknown: {
          title: forwardedSource.avatarTitle,
          userId: forwardedSource.senderId,
          chatId: forwardedSource.groupId || message.groupId,
          messageId: forwardedSource.messageId,
        },
      }
    : {
        unknown: {
          title: '',
          userId: message.senderId,
          chatId: message.groupId,
          messageId: message.id,
        },
      };

  const quote = new Quote({
    text,
    source,
  });

  if (!quote) {
    return;
  }

  const inputPanel = Entities.InputPanelsStore.activeInputPanel;
  const activeGroup = Entities.GroupsStore.activeGroup;

  if (!inputPanel || !activeGroup) {
    return;
  }

  // You can't make quotes in public if you're not admin
  if (activeGroup.isChannel && !activeGroup.withMeInAdmins) {
    return;
  }

  if (inputPanel.editMessage) {
    const isEndEditMessageSuccess = await Tasks.messaging.endEditMessage(activeGroup.id);

    if (!isEndEditMessageSuccess) {
      return;
    }
  }

  inputPanel.setQuote(quote);
  bus.messaging.broadcastStartQuote();
};
